import { render, staticRenderFns } from "./Ewallet.vue?vue&type=template&id=506ec710"
import script from "./Ewallet.vue?vue&type=script&lang=js"
export * from "./Ewallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports